import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/lib/queryClient';

export interface EmailTemplate {
  id: number;
  userId: number;
  name: string;
  category: string;
  subject: string;
  bodyHtml: string;
  bodyText?: string | null;
  defaultSignatureId?: number | null;
  trackOpens: boolean;
  separateUntilReply: boolean;
  status: 'active' | 'deleted';
  createdAt: string;
  updatedAt: string;
  archivedAt?: string | null;
}

export const EMAIL_TEMPLATES_QUERY_KEY = ['/api/email/templates'] as const;

export function useEmailTemplates(enabled = true) {
  return useQuery<EmailTemplate[]>({
    queryKey: EMAIL_TEMPLATES_QUERY_KEY,
    queryFn: async () => {
      const result = await apiRequest('/api/email/templates');
      return Array.isArray(result) ? result : [];
    },
    enabled,
    staleTime: 30_000,
  });
}
